import { IGeoRoadInfo } from '../../types/geo';
import { IApplicationState } from '../../types/redux';

export function getRoadInfo(state: IApplicationState): IGeoRoadInfo[] | null {
  const {
    newbuilding: { geo },
  } = state;

  if (geo && geo.roadInfo && geo.roadInfo.length) {
    return geo.roadInfo;
  }

  return null;
}

export function getFirstRoadInfo(state: IApplicationState): IGeoRoadInfo | null {
  const road = getRoadInfo(state);

  if (road && road[0] && road[0].name && road[0].distance) {
    return road[0];
  }

  return null;
}
